import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Pianificare le mie lezioni di fitness senior mi richiedeva ore ogni settimana. Adesso apro semplicemente il sistema e insegno. Ai miei partecipanti piace moltissimo la struttura e finalmente ho recuperato i miei fine settimana.',
  author: 'Giulia F.',
  role: 'Istruttrice Fitness Senior',
  location: 'Milano, Italia'
}, {
  text: 'Solo il bonus delle Cheat Sheets di adattamento vale il prezzo. Tutto è organizzato e facile da implementare. Mi sento molto più sicuro sapendo di offrire una programmazione sicura ed efficace ai miei anziani.',
  author: 'Marco B.',
  role: 'Coach di Attività Motoria Adattata',
  location: 'Roma, Italia'
}, {
  text: 'Lavoro con più livelli di abilità e questo sistema mi ha finalmente dato un framework di cui posso fidarmi. Le sessioni con la sedia sono state un punto di svolta per i miei partecipanti con mobilità ridotta.',
  author: 'Silvia R.',
  role: 'Coordinatrice Fitness Comunitario',
  location: 'Torino, Italia'
}, {
  text: "Le sessioni pronte all'uso mi hanno fatto risparmiare innumerevoli ore. Avrei voluto trovarlo anni fa. Elimina tutte le congetture nella pianificazione e mi permette di concentrarmi completamente sull'allenamento e sulla connessione con la mia classe.",
  author: 'Davide M.',
  role: 'Personal Trainer',
  location: 'Napoli, Italia'
}, {
  text: 'Come professionista che si stava spostando verso il fitness senior, mi sentivo sopraffatta da cosa fosse sicuro insegnare. Questo sistema 6 in 1 mi ha dato il piano esatto di cui avevo bisogno. Le mie classi sono piene e i miei allievi vedono miglioramenti reali nella mobilità quotidiana.',
  author: 'Laura C.',
  role: 'Istruttrice Fitness di Gruppo',
  location: 'Bologna, Italia'
}];
export function Testimonials() {
  return <section className="py-10 px-4 sm:px-6 bg-cream border-y-4 border-ivory" data-id="element-177">
      <div className="text-center mb-8" data-id="element-178">
        <h2 className="text-2xl sm:text-4xl font-heading font-bold text-petrol mb-2 leading-tight uppercase" data-id="element-179">
          Cosa Dicono Altri Professionisti
        </h2>
        <p className="text-sm sm:text-base font-body font-bold text-sage uppercase tracking-widest" data-id="element-180">
          Testimonianze di professionisti
        </p>
      </div>

      <div className="flex flex-col gap-4 max-w-4xl mx-auto" data-id="element-181">
        {testimonials.map((t, i) => <div key={i} className="bg-ivory border border-gold/30 p-5 sm:p-6 rounded-xl shadow-md" data-id="element-182">
            <div className="flex gap-1 mb-3" data-id="element-183">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-gold text-gold" data-id="element-184" />)}
            </div>
            <p className="text-graphite font-medium mb-4 leading-relaxed italic text-base sm:text-lg font-subheading" data-id="element-185">
              "{t.text}"
            </p>
            <div className="border-t border-gold/20 pt-4 flex items-center gap-4" data-id="element-186">
              <div className="w-12 h-12 rounded-full bg-petrol/10 flex items-center justify-center text-petrol font-bold text-lg border border-petrol/20 font-heading shrink-0" data-id="element-187">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-188">
                <p className="font-bold text-petrol text-sm sm:text-base font-body" data-id="element-189">
                  — {t.author}
                </p>
                <p className="text-xs text-graphite/70 font-bold uppercase tracking-widest mt-1" data-id="element-190">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}